/**
 * FnCatalog container
 */
import { withRouter } from 'react-router-dom';
import FnCatalogV2 from '../../Components/FnCatalogV2/FnCatalog';

/**
 * Connects dashboard state to the FnCatalog component

 * @param {object} mapStateToProps data object to become props for the FnCatalog component
 * @param {object} mapDispatchToProps actions to be dispatched to reducer
 */
export default withRouter(FnCatalogV2);
